import { qs } from "@fluorescent/dom";
import { formatMoney } from "@/glow";
import { on } from "@/glow/events";

const selectors = {
  progressBar: ".free-shipping-bar__bar",
  message: ".free-shipping-bar__message",
};

export default function freeShippingBar(node) {
  if (!node) return;

  let {
    threshold,
    cartTotal,
    freeShippingSuccessMessage,
    freeShippingPendingMessage,
  } = node.dataset;

  let thresholdInCents;

  const events = [];

  _initFreeShippingBar();

  function _initFreeShippingBar() {
    cartTotal = parseInt(cartTotal, 10);

    // Account for different currencies using the Shopify currency rate
    threshold = Math.round(
      parseInt(threshold, 10) * (window.Shopify?.currency?.rate || 1)
    );

    thresholdInCents = threshold * 100;

    _setProgressMessage();
    _setProgressBar();
    node.dataset.isLoaded = true;

    events.push(on("cart:updated", ({ cart }) => _updateFreeShippingBar(cart)));
  }

  function _updateFreeShippingBar(cart) {
    cartTotal = cart.total_price;
    _setProgressMessage();
    _setProgressBar();
  }

  function _setProgressMessage() {
    const message = qs(selectors.message, node);

    if (cartTotal >= thresholdInCents) {
      node.dataset.isOverThreshold = true;
      message.innerText = freeShippingSuccessMessage;
    } else {
      const remainder = Math.abs(cartTotal - thresholdInCents);

      node.dataset.isOverThreshold = false;
      message.innerHTML = freeShippingPendingMessage.replace(
        "{{ remaining_amount }}",
        `<span class="fs-body-bold">${formatMoney(remainder)}</span>`
      );
    }
  }

  function _setProgressBar() {
    const progressBar = qs(selectors.progressBar, node);
    const progress = cartTotal < thresholdInCents ? cartTotal / threshold : 100;

    progressBar.style.setProperty("--progress-width", `${progress}%`);
  }

  function unload() {
    events.forEach(unsubscribe => unsubscribe());
  }

  return { unload };
}
